import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import styles from "../../appointmentsPage.module.css";
import { IOverbookingSuggestion } from "../../types/noShowPredictor.types";

interface IOverbookingSuggestionsProps {
  suggestions: IOverbookingSuggestion[];
  onApply: (suggestion: IOverbookingSuggestion) => void;
}

// Map day index to translation key
const getDayKey = (date: string): string => {
  const dayIndex = new Date(date).getDay();
  const dayKeys = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
  return dayKeys[dayIndex];
};

/**
 * Smart overbooking suggestions section
 */
const OverbookingSuggestions: React.FC<IOverbookingSuggestionsProps> = ({ 
  suggestions, 
  onApply 
}) => {
  return (
    <div className={styles.overbookingSection}>
      <div className={styles.overbookingHeader}>
        <div className={styles.overbookingIcon}>🎲</div>
        <div>
          <div className={styles.overbookingTitle}>{t("NOSHOW_OVERBOOKING_TITLE")}</div>
        </div>
      </div>
      <div className={styles.overbookingDescription}>
        {t("NOSHOW_OVERBOOKING_DESC")}
      </div>

      <div className={styles.suggestionCards}>
        {suggestions.map(suggestion => (
          <div 
            key={suggestion.id} 
            className={styles.suggestionCard}
            onClick={() => onApply(suggestion)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onApply(suggestion)}
          >
            <div className={styles.suggestionHeader}>
              <div className={styles.suggestionTime}>
                {t(`APPOINTMENTS_DAY_${getDayKey(suggestion.date)}`)} {suggestion.date.split('-').slice(1).reverse().join('/')} • {suggestion.timeSlot}
              </div>
              <div className={styles.confidenceScore}>
                {suggestion.confidenceScore}%
              </div>
            </div>
            <div className={styles.suggestionDetails}>
              {suggestion.therapistName} - {suggestion.reason}
            </div>
            <div className={styles.suggestionStats}>
              <div className={styles.suggestionStat}>
                <div className={styles.statValueSmall}>{suggestion.scheduledAppointments}</div>
                <div className={styles.statLabelSmall}>{t("NOSHOW_SCHEDULED")}</div>
              </div>
              <div className={styles.suggestionStat}>
                <div className={styles.statValueSmall}>+{suggestion.suggestedAdditions}</div>
                <div className={styles.statLabelSmall}>{t("NOSHOW_ADD_APPOINTMENT")}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OverbookingSuggestions;
